let getters = {
  activeTransaction (state) {
    return state.activeTransaction
  },
  settledTransactions (state) {
    return state.settledTransactions
  },
  settledTxnError(state){

    return state.settledTxnError

  }
}
export default getters



// WEBPACK FOOTER //
// ./src/store/transaction/getters.js